var map = {
	"./cambio-entrenamientos.svg": 6263,
	"./cambio-inteligente-de-receta.svg": 7330,
	"./chat-con-tu-nutricionista.svg": 6638,
	"./chat-nuticionista.svg": 7993,
	"./conciliacion-parejas.svg": 865,
	"./grafico-evolucion.svg": 9732,
	"./lista-de-la-compra.svg": 5906,
	"./patologias.svg": 3575,
	"./plan-nutricional.svg": 3622,
	"./reajustes-automaticos.svg": 1365,
	"./sincronizacion.svg": 922,
	"./suplementacion.svg": 9097,
	"./videoconsulta.svg": 885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9611;